import { ElementType, Template, GlobalConfig } from "@/types/builder";

const generateId = (): string => {
  return Math.random().toString(36).substr(2, 9);
};

export const createMobileNavigationPopup = (
  globalConfig: GlobalConfig
): Template => ({
  id: "mobile-navigation",
  name: "Mobile Navigation",
  industry: "template1",
  elements: [
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        backgroundColor: "#2D2D2D",
        borderRadius: "0",
        padding: "48px 16px 32px 16px",
        margin: "0",
        width: "100vw",
        maxWidth: "100vw",
        minWidth: "100vw",
        height: "100vh",
        minHeight: "100vh",
        position: "fixed",
        top: "0",
        left: "0",
        right: "0",
        bottom: "0",
        display: "flex",
        flexDirection: "column",
        zIndex: "9999",
      },
      children: [
        // Navigation links
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            display: "flex",
            flexDirection: "column",
            gap: "40px",
            margin: "100px 0 0 0",
            alignItems: "center",
          },
          children: [
            {
              id: generateId(),
              type: "link" as ElementType,
              content: "About",
              styles: {
                fontFamily: "Poppins, sans-serif",
                fontSize: "28px",
                fontStyle: "normal",
                fontWeight: "400",
                lineHeight: "55px",
                textAlign: "center",
                margin: "0",
                color: "#FFFFFF",
                textDecoration: "none",
              },
            },
            {
              id: generateId(),
              type: "link" as ElementType,
              content: "Benefits",
              styles: {
                fontFamily: "Poppins, sans-serif",
                fontSize: "28px",
                fontStyle: "normal",
                fontWeight: "400",
                lineHeight: "55px",
                letterSpacing: "-1.14px",
                textAlign: "center",
                margin: "0",
                color: "#FFFFFF",
                textDecoration: "none",
              },
            },
            {
              id: generateId(),
              type: "link" as ElementType,
              content: "FAQ",
              styles: {
                fontFamily: "Poppins, sans-serif",
                fontSize: "28px",
                fontStyle: "normal",
                fontWeight: "400",
                lineHeight: "55px",
                letterSpacing: "-1.14px",
                textAlign: "center",
                margin: "0",
                color: "#FFFFFF",
                textDecoration: "none",
              },
            },
            {
              id: generateId(),
              type: "button" as ElementType,
              content: "ORDER NOW",
              styles: {
                backgroundColor: "#F4C430",
                color: "#000000",
                padding: "12px 24px",
                borderRadius: "8px",
                fontWeight: "600",
                fontSize: "16px",
                border: "none",
                cursor: "pointer",
                fontFamily: "Poppins, sans-serif",
                marginTop: "20px",
                width: "auto",
                alignSelf: "center",
              },
            },
          ],
        },
      ],
    },
  ],
});
